import React from "react";

const Ribbon = ({ stroke = "#C1106A" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_12416_19544)">
        <path
          d="M10.3217 8.59375L11.3317 14.2778C11.3431 14.3447 11.3337 14.4135 11.3048 14.4749C11.276 14.5364 11.2291 14.5875 11.1704 14.6216C11.1116 14.6557 11.0439 14.671 10.9763 14.6656C10.9086 14.6601 10.8442 14.6341 10.7917 14.5911L8.40507 12.7997C8.28986 12.7137 8.14989 12.6672 8.00607 12.6672C7.86225 12.6672 7.72229 12.7137 7.60707 12.7997L5.21641 14.5904C5.16395 14.6334 5.09965 14.6593 5.03207 14.6648C4.96449 14.6702 4.89686 14.655 4.83818 14.621C4.77951 14.587 4.73259 14.536 4.70369 14.4746C4.67478 14.4133 4.66527 14.3446 4.67641 14.2778L5.68574 8.59375"
          stroke={stroke}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 9.33398C10.2091 9.33398 12 7.54312 12 5.33398C12 3.12485 10.2091 1.33398 8 1.33398C5.79086 1.33398 4 3.12485 4 5.33398C4 7.54312 5.79086 9.33398 8 9.33398Z"
          stroke={stroke}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12416_19544">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ribbon;
